import FormControl from '~/common/components/Forms/FormControl';
import FormLabel from '~/common/components/Forms/FormLabel';
import Radio from '~/common/components/Radios/Radio';
import Text from '~/common/components/Texts/Text';
import RadioGroup from '~/common/mui/Radios/MUIRadioGroup/RadioGroup';

const disabledStyles = {
  opacity: 0.6,
};

type FormBuilderRadioButtonsProps = {
  name?: string;
  label?: string;
  value?: string;
  register?: (...args: any[]) => any;
  isChecked?: (...args: any[]) => any;
  options?: any;
  getValues?: (...args: any[]) => any;
  onChangeHandler?: (...args: any[]) => any;
  disabled?: boolean;
};

export const FormBuilderRadioButtons = ({
  name,
  label,
  options,
  value,
  isChecked,
  onChangeHandler,
  getValues,
  disabled,
}: FormBuilderRadioButtonsProps) => (
  <FormControl>
    <FormLabel htmlFor={name}>{label}</FormLabel>

    {options.map((option, i) => {
      return (
        <Radio
          marginLeft={i > 0 ? '1rem' : ''}
          key={option.value}
          name={name}
          value={option.value}
          isDisabled={disabled}
          style={disabled ? disabledStyles : {}}
          isChecked={
            isChecked
              ? isChecked(option.value)
              : getValues(value) === option.value
          }
          onClick={() => {
            if (!disabled) onChangeHandler(option.value);
          }}
        >
          <Text style={disabled ? disabledStyles : {}}>{option.label}</Text>
        </Radio>
      );
    })}
  </FormControl>
);

type FormBuilderRadioGroupProps = {
  name?: string;
  label?: string;
  value?: string;
  options?: any;
  getValues?: (...args: any[]) => any;
  onChangeHandler?: (...args: any[]) => any;
  disabled?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  marginTop?: string;
};

export const FormBuilderRadioButtonGroup = ({
  name,
  label,
  options,
  value,
  onChangeHandler,
  getValues,
  disabled,
  isRequired = false,
  isInvalid,
  marginTop,
}: FormBuilderRadioGroupProps) => {
  return (
    <RadioGroup
      name={name}
      marginTop={marginTop}
      label={label}
      options={options}
      value={String(getValues(value))}
      onChange={onChangeHandler}
      disabled={disabled}
      required={isRequired}
      error={isInvalid}
    />
  );
};
